import { render, staticRenderFns } from "./AbnormalDialog.vue?vue&type=template&id=ddc16cf2"
import script from "./AbnormalDialog.vue?vue&type=script&lang=js"
export * from "./AbnormalDialog.vue?vue&type=script&lang=js"
import style0 from "./AbnormalDialog.vue?vue&type=style&index=0&id=ddc16cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports